export const CLIENT_VERSION = "v2.1.0dev-build8";
export const SERVER_VERSION = "v1.0.1";